// extracted by mini-css-extract-plugin
module.exports = {"form-input-wrapper":"form-input-wrapper__1FYwL","error":"error__2Sxkg","form-input":"form-input__3V28H","account-page-form-input":"account-page-form-input__2tp8P"};